module.exports = __webpack_public_path__ + "static/media/pastevents_bottom_photo.1ca7acf9.jpg";